import { FC } from 'react'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'react-i18next'
import Layout from 'components/layout/Layout'
import Referral from 'features/referral/Referral'
import request, { getAxiosRequestConfig } from 'utils/request'
import { ReferralProps } from 'features/referral/types'

const ReferralPage: FC<ReferralProps> = (props) => {
  // I18N
  const { t } = useTranslation('referral')
  const { locale: language } = useRouter()

  const { referralCode, host } = props

  /**
   * Provides correct SEO image
   */
  const getSEOImage = () => {
    let image

    if (!referralCode) {
      if (language === 'nl') {
        image = '/images/features/referral/referral-seo-nl.jpg'
      } else {
        image = '/images/features/referral/referral-seo-fr.jpg'
      }
    } else {
      if (language === 'nl') {
        image = '/images/features/referral/referral-seo-referred-nl.jpg'
      } else {
        image = '/images/features/referral/referral-seo-referred-fr.jpg'
      }
    }

    return `https://${host}${image}` // MUST be absolute url
  }

  return (
    <Layout>
      <Head>
        <title>
          {referralCode
            ? t('titleReferred', 'Registreer je nu bij Bolt via deze link')
            : t('title', 'Overtuig een vriend en win samen 2 e-bikes')}
        </title>
        <meta property="og:image" content={getSEOImage()} key="image" />
        <meta
          property="og:title"
          content={
            referralCode
              ? t('titleReferred', 'Registreer je nu bij Bolt via deze link')
              : t('title', 'Overtuig een vriend en win samen 2 e-bikes')
          }
          key="title"
        />
        <meta
          property="og:description"
          content={
            referralCode
              ? t('descriptionReferred', 'Jullie hebben 1 kans op 50 om te winnen')
              : t('description', 'Jullie hebben 1 kans op 50 om te winnen')
          }
        />
      </Head>
      <Referral {...props} />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, query, req } = context
  const { referralcode: code } = query
  let referralCode = null

  if (code) {
    try {
      // get referralcode data from API
      const response = await request(getAxiosRequestConfig('POST', 'checkPromoReferralCode', { code }))
      const { data } = response
      referralCode = data
    } catch (e) {
      throw new Error(e)
    }
  }

  return {
    props: {
      ...(await serverSideTranslations(locale)),
      referralCode,
      host: req.headers.host
    }
  }
}

export default ReferralPage
